/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetMediaExportJobsByIdQueryResponse, WebAppGetMediaExportJobsByIdPathParams, WebAppGetMediaExportJobsById401, WebAppGetMediaExportJobsById403, WebAppGetMediaExportJobsById404 } from "../models/WebAppGetMediaExportJobsById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetMediaExportJobsById } from "../axios/webAppGetMediaExportJobsById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetMediaExportJobsByIdQueryKey = (id: WebAppGetMediaExportJobsByIdPathParams["id"]) => ["api-v2", { url: '/web-app/v1/export-jobs/:id', params: {id:id} }] as const

export type WebAppGetMediaExportJobsByIdQueryKey = ReturnType<typeof webAppGetMediaExportJobsByIdQueryKey>

export function webAppGetMediaExportJobsByIdQueryOptions(id: WebAppGetMediaExportJobsByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetMediaExportJobsByIdQueryKey(id)
        return queryOptions<WebAppGetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<WebAppGetMediaExportJobsById401 | WebAppGetMediaExportJobsById403 | WebAppGetMediaExportJobsById404>, WebAppGetMediaExportJobsByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetMediaExportJobsById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a single export job for the current user. Result includes fileSize only when completed (no storage URL).
 * @summary Get export job by id
 * {@link /web-app/v1/export-jobs/:id}
 */
export function useWebAppGetMediaExportJobsById<TData = WebAppGetMediaExportJobsByIdQueryResponse, TQueryData = WebAppGetMediaExportJobsByIdQueryResponse, TQueryKey extends QueryKey = WebAppGetMediaExportJobsByIdQueryKey>(id: WebAppGetMediaExportJobsByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetMediaExportJobsByIdQueryResponse, ResponseErrorConfig<WebAppGetMediaExportJobsById401 | WebAppGetMediaExportJobsById403 | WebAppGetMediaExportJobsById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetMediaExportJobsByIdQueryKey(id)
         

         const query = useQuery({
          ...webAppGetMediaExportJobsByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetMediaExportJobsById401 | WebAppGetMediaExportJobsById403 | WebAppGetMediaExportJobsById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}